





import Component from 'vue-class-component';
import { Base } from '@/base';

@Component({
  name: 'ErrorPage'
})
export default class ErrorPage extends Base {
};
